import { Receipt } from "@bokio/components/Receipt/Receipt";
import { Modal, ModalContent } from "@bokio/designsystem/components/Modal";

import * as styles from "./ModalWithReceipt.scss";

interface ModalWithReceiptProps {
	visible: boolean;
	onClose: () => void;
	title: string;
	receiptId: string;
	children: React.ReactNode;
}

export const ModalWithReceipt = ({ visible, onClose, title, receiptId, children }: ModalWithReceiptProps) => {
	return (
		<Modal visible={visible} onClose={onClose} title={title} width="fullWidth" testId="CategoryModal">
			<ModalContent>
				<div className={styles.container}>
					<div className={styles.left}>{children}</div>
					<div className={styles.right}>
						<Receipt receiptId={receiptId} allowRotate={true} className={styles.receipt} />
					</div>
				</div>
			</ModalContent>
		</Modal>
	);
};
